import type {ReactNode} from 'react';
import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {Sheet, SheetContent} from '@/components/ui/sheet';

import {useSheetSidebarStore} from './useSheetSidebar';

export type SheetSidebarProps = {
  children: ReactNode;
};
const SheetSidebar = ({children}: SheetSidebarProps) => {
  const setOpen = useSheetSidebarStore(state => state.setOpen);
  const open = useSheetSidebarStore(state => state.open);

  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location, setOpen]);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="left">{children}</SheetContent>
    </Sheet>
  );
};

export default SheetSidebar;
